(() => {
 const boot = (mountedRoot) => {
  if (!document.querySelector('[data-nt-layout-preview]')) return;
  const root = mountedRoot || document.querySelector('[data-nt-product]');
  if (!root || root.dataset.ntLayoutMounted) return;
  root.dataset.ntLayoutMounted = 'true';
  const quantity = root.querySelector('[data-nt-quantity]');
  if (quantity) {
   const input=quantity.querySelector('input');
   const set=value=>{input.value=String(Math.max(1,Math.min(99,parseInt(value,10)||1)));input.dispatchEvent(new Event('change',{bubbles:true}));};
   quantity.querySelectorAll('[data-nt-quantity-step]').forEach(button=>button.addEventListener('click',()=>set(Number(input.value)+Number(button.dataset.ntQuantityStep))));
   input.addEventListener('blur',()=>set(input.value));
  }

  root.setAttribute('data-nt-layout-mounting', '');
  const show = () => {
   root.removeAttribute('data-nt-layout-mounting');
   document.getElementById('nt-pdp-first-paint')?.remove();
  };
  const fallback = setTimeout(show, 4000);
  const mobileBar=root.querySelector('.nt-pdp__mobile-bar');
  if (mobileBar && quantity) {
   const form=root.querySelector('.nt-pdp__form'),input=quantity.querySelector('input');
   const placeholder=document.createComment('Quantity position');quantity.before(placeholder);
   const mobile=matchMedia('(max-width:767px)');
   const placeQuantity=()=>{
    const formId=form?.getAttribute('id');if(formId)input.setAttribute('form',formId);
    mobileBar.hidden=false;
    if (mobile.matches) {if(quantity.parentElement!==mobileBar)mobileBar.prepend(quantity);}
    else if(placeholder.nextSibling!==quantity)placeholder.after(quantity);
   };
   mobile.addEventListener('change',placeQuantity);placeQuantity();
   root.addEventListener('nt:product:unload',()=>{mobile.removeEventListener('change',placeQuantity);},{once:true});
  }
  let scheduled = false;
  const arrange = () => {
   scheduled = false;
   const row = root.querySelector('.nt-pdp__title-row');
   const actions = root.querySelector('.nt-pdp__product-actions');
   if (row && actions && actions.parentElement !== row) row.append(actions);
   const gallery = root.querySelector('.nt-pdp__main-image');
   const photos = root.querySelectorAll('[data-nt-product-thumb]:not([data-nt-360-thumb])');
   if (gallery) gallery.classList.toggle('nt-media-has-pages', photos.length > 1);
   let subline = row?.querySelector('.nt-pc-title-subline');
   const title = root.dataset.productTitle || '';
   const heading = row?.querySelector('h1');
   const yearValues = (root.dataset.modelYears || '').split(',').filter(Boolean);
   if (heading && root.dataset.vehicleBrand && root.dataset.vehicleModels && yearValues.length) {
    if (!subline) {subline = document.createElement('p');subline.className='nt-pc-title-subline';row.append(subline);}
    let years = root.querySelector('.nt-home-product-years');
    if (!years) {years=document.createElement('span');years.className='nt-home-product-years';years.textContent=yearValues[0]+(yearValues.length>1?'–'+yearValues[yearValues.length-1]:'');}
    if (years.parentElement!==subline)subline.prepend(years);
   }
   const model = row?.querySelector('.nt-home-product-model');
   if (subline && model) {
    const delivery = root.querySelector('.nt-shared-delivery > div');
    const badge = row.querySelector('.nt-us-stock-label,.nt-presale-label,.nt-made-order-label');
    if (badge && delivery) {
     if (delivery.querySelector('.nt-us-stock-label,.nt-presale-label,.nt-made-order-label')) badge.remove();
     else delivery.prepend(badge);
    }
    const prefix = row.querySelector('.nt-home-product-prefix');
    if (prefix && root.dataset.vehicleBrand && prefix.textContent !== root.dataset.vehicleBrand) prefix.textContent = root.dataset.vehicleBrand;
    row.classList.remove('nt-title-two-rows');
    row.classList.add('nt-title-refined');
   }
   if (subline) {
    const years = root.querySelector('.nt-home-product-years');
    const design = title.match(/\bN\d+\b/i);
    let code = subline.querySelector('.nt-title-design-code');
    if (design) {
     if (!code) {code=document.createElement('span');code.className='nt-title-design-code';}
     const value=design[0].toUpperCase();
     if (code.textContent!==value) code.textContent=value;
    } else code=null;
    const fitment = subline.querySelector('.nt-fitment-check');
    const content = [years,code,fitment].filter(Boolean);
    if (content.length!==subline.childNodes.length || content.some((node,index)=>subline.childNodes[index]!==node)) subline.replaceChildren(...content);
   }
   const colors = root.querySelector('.nt-us-color-links');
   const colorHeading = colors?.querySelector('h2');
   const selectedColor = colors?.querySelector('.nt-us-color-links__selected');
   if (colorHeading && selectedColor && !colorHeading.contains(selectedColor)) colorHeading.append(selectedColor);
   const price = root.querySelector('.nt-pdp__price');
   const installments = root.querySelector('afterpay-placement');
   const anchor = root.querySelector('.nt-pdp__afterpay');
   const fitment = row?.querySelector('.nt-fitment-check');
   if (fitment && subline && fitment.parentElement !== subline) subline.append(fitment);
   if (price && installments) {
    let paymentRow = root.querySelector('.nt-price-installment-row');
    if (!paymentRow) { paymentRow = document.createElement('div'); paymentRow.className = 'nt-price-installment-row'; price.before(paymentRow); paymentRow.append(price); }
    if (installments.parentElement !== paymentRow) paymentRow.append(installments);
   }
   const form = root.querySelector('.nt-pdp__form');
   const extras = form?.querySelector('.nt-gift-bundle--pdp');
   const purchase = root.querySelector('.nt-pc-buy-dock') || root.querySelector('.nt-pdp__purchase-actions');
   if (form && extras && purchase && !purchase.contains(form)) {
    if (purchase.parentElement !== form) form.append(purchase);
    if (extras.nextElementSibling !== purchase) form.insertBefore(extras, purchase);
   }
  };
  const observer = new MutationObserver(() => {
   if (scheduled) return;
   scheduled = true;
   requestAnimationFrame(arrange);
  });
  observer.observe(root, { childList: true, subtree: true });
  root.addEventListener('nt:product:unload', () => {observer.disconnect();clearTimeout(fallback);}, {once:true});
  arrange();
  requestAnimationFrame(() => requestAnimationFrame(() => {
   show();
   clearTimeout(fallback);
   clearTimeout(window.ntPdpPaintFallback);
   root.setAttribute('data-nt-first-paint-ready', 'true');
  }));
 };
 document.addEventListener('nt:product:mount', event => {
  if (event.target.matches?.('[data-nt-product]')) boot(event.target);
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
 else boot();
})();





